import { HorseshoeConfig } from '../../shared/types/podlet';

function isEmpty(input: string | null) {
    if (input && typeof input === 'string') {
        const trimmed = input.trim();
        if (trimmed.length) {
            return false;
        }
    }
    return true;
}

function getScriptElementData(id: string) {
    const appNexusScriptElement = document.getElementById(id);
    if (appNexusScriptElement) {
        const { textContent } = appNexusScriptElement;
        if (textContent && isEmpty(textContent) === false) {
            try {
                const parsed = JSON.parse(textContent);
                return parsed;
            } catch (error) {
                console.error(`Error in parsing ${id}`, error);
            }
        }
    }

    return {};
}

export function getPodletConfigFromHtml() {
    const config = getScriptElementData('horseshoe-config') as HorseshoeConfig;
    return config;
}
